import { useState } from "react";
const API_BASE = process.env.REACT_APP_API_BASE_URL || "http://localhost:5001";

const initialState = {
  from_name: "",
  reply_to: "",
  message: "",
};

export const Contact = (props) => {
  const [{ from_name, reply_to, message }, setState] = useState(initialState);
  const [submissionStatus, setSubmissionStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };

  const clearState = () => setState({ ...initialState });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(`${API_BASE}/api/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ from_name, reply_to, message }),
      });
      if (res.ok) {
        setSubmissionStatus({
          message: "Your message has been sent successfully!",
          type: "success",
        });
        clearState();
      } else {
        setSubmissionStatus({
          message: "Oops! Something went wrong. Please try again later.",
          type: "error",
        });
      }
    } catch (err) {
      setSubmissionStatus({
        message: "Oops! Something went wrong. Please try again later.",
        type: "error",
      });
    }
  };

  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2>Get In Touch</h2>
                <p>
                  Please fill out the form below to send us an email and we will
                  get back to you as soon as possible.
                </p>
              </div>
              {submissionStatus && (
                <div
                  className={`alert ${
                    submissionStatus.type === "success"
                      ? "alert-success"
                      : "alert-danger"
                  }`}
                  role="alert"
                >
                  {submissionStatus.message}
                </div>
              )}
              {/* === FORM START === */}
              <form name="sentMessage" onSubmit={handleSubmit}>
                <div className="row form-group-input-pair">
                  {/* Name Input - will be 50% width of the row */}
                  <div className="col-sm-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="name"
                        name="from_name"
                        className="form-control"
                        placeholder="Name"
                        required
                        onChange={handleChange}
                        value={from_name}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="reply_to"
                        className="form-control"
                        placeholder="Email"
                        required
                        onChange={handleChange}
                        value={reply_to}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    className="form-control"
                    rows="4"
                    placeholder="Message"
                    required
                    onChange={handleChange}
                    value={message}
                  ></textarea>
                  <p className="help-block text-danger"></p>
                </div>
                <div id="success"></div>
                <button type="submit" className="btn btn-custom btn-lg">
                  Send Message
                </button>
              </form>
              {/* === FORM END === */}
            </div>
          </div>
          <div className="col-md-3 col-md-offset-1 contact-info">
            <div className="contact-item">
              <h3>Contact Info</h3>
              <p>
                <span>
                  <i className="fa fa-map-marker"></i> Address
                </span>
                {props.data ? props.data.address : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-phone"></i> Phone
                </span>{" "}
                {props.data ? props.data.phone : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o"></i> Email
                </span>{" "}
                {props.data ? props.data.email : "loading"}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
